import Attributes from './Attributes'
import InstanceTree from './InstanceTree'
import ProjectQueries from './ProjectQueries'
import Feather from '@sysunite/react-feather'
import { getProjectData } from 'Services/WeaverUtils'

FancyEmpty = ({ title, icon }) ->
  <div style={{ paddingTop: '20vh', opacity: 0.6 }}>
    <Feather type={icon} style={{ padding: '0 40%', color: '#e5eaec' }} />
    <h1
      style={{
        fontWeight: 600
        fontFamily: 'Roboto Condensed'
        textAlign: 'center'
        textTransform: 'uppercase'
        color: '#e5eaec'
        fontSize: '2rem'
        letterSpacing: 14
      }}
    >{ title }</h1>
  </div>


tabs = [{
  key: 'home'
  icon: 'home'
  Component: ProjectQueries
}, {
  key: 'elements'
  icon: 'hexagon'
  Component: InstanceTree
  initiallyDisabled: true
}, {
  key: 'attributes'
  icon: 'align-left'
  Component: Attributes
  initiallyDisabled: true
}]


### Temporarily Hidden

{
  key: 'favourites'
  icon: 'heart'
  component: -> <FancyEmpty title={'favourites'} icon={'star'} />
}

try
  if getProjectData().modelName and getProjectData().modelVersion
    tabs = tabs.slice(0,1).concat([{
      key: 'model'
      icon: 'aperture'
      component: ModelViewer
    }]).concat(tabs.slice(1))

###

export default tabs
